import React from 'react';
import classNames from 'classnames/bind';
import styles from '../../../styles.pcss';
const cx = classNames.bind(styles);

export const PopupSectionPrice = ({ children }) => (
  <div className={cx('price')}>
    {children}
  </div>
);
